import React, { KeyboardEvent, MouseEvent, ReactNode } from "react";

import {
  AudioStrippedButton,
  IconWrapper
} from "../YleAudioPlayer/AudioPlayerButtons";

const IconButton = ({
  children,
  ...props
}: {
  "aria-label": string;
  children: ReactNode;
  isMobile: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  onFocus?: () => void;
  onKeyDown?: (e: KeyboardEvent<HTMLButtonElement>) => void;
  onMouseOver?: () => void;
}) => (
  <AudioStrippedButton {...props}>
    <IconWrapper>{children}</IconWrapper>
  </AudioStrippedButton>
);

export default IconButton;
